// ExpandGlyph — the exact toggle mark imported from the Figma design (Group 38):
// two opposing corner brackets (top-right + bottom-left), no diagonals. The SAME
// mark serves both the card's expand affordance and the expanded view's collapse
// toggle — sized by its frosted rounded-square button via CSS. currentColor stroke.
export default function ExpandGlyph() {
  return (
    <svg viewBox="0 0 16.6758 17.0985" fill="none" aria-hidden preserveAspectRatio="xMidYMid meet">
      <path d="M10.7234 0.758732V5.95239H15.917" stroke="currentColor" strokeWidth="1.51746" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.95239 16.3398V11.1461H0.758732" stroke="currentColor" strokeWidth="1.51746" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
